import Team from './Team'
export default class PoolTeam extends Team {
  dualWins = 0
  dualLosses = 0
  matchWins = 0
  matchLosses = 0
  setLosses = 0
  setWins = 0
  pointsFor = 0
  pointsAgainst = 0

  constructor (sdk, dto) {
    super(sdk, dto, 'pool')
    this.poolId = this.poolId || 0
    this.teamId = this.teamId || 0
    this.slot = this.slot || 0
  }

  get dualsPlayed () { return this.dualWins + this.dualLosses }
  get dualWinRatio () { return this.dualWins === 0 ? -this.dualLosses : this.dualWins / this.dualsPlayed }
  get matchesPlayed () { return this.matchWins + this.matchLosses }
  get matchWinRatio () { return this.matchWins === 0 ? -this.matchLosses : this.matchWins / this.matchesPlayed }
  get setsPlayed () { return this.setWins + this.setLosses }
  get setWinRatio () { return this.setWins === 0 ? -this.setLosses : this.setWins / this.setsPlayed }
  get pointDiff () { return this.pointsFor - this.pointsAgainst }
  get pointDiffRatio () { return this.matchesPlayed ? this.pointsFor + this.pointsAgainst === 0 ? 0 : this.pointsFor / this.pointsAgainst : null }
  get matchPoints () { return (this.matchWins * 2) + (this.matchLosses * 1) }
}
